import { onMount, onCleanup } from "solid-js";
import splashVideoPlayer from "../../videoPreview";
import { clientBranding, refreshBranding } from "../../config/clientConfig";

const SplashScreen = (props) => {
  onMount(() => {
    console.log("=== SplashScreen mounted ===");

    // Re-check bridge now DOM is ready; also wipe any stale cached client so
    // the bridge value always wins over a previous install's localStorage.
    localStorage.removeItem("applay_client");
    console.log("🔄 refreshBranding called, bridge clientId: here");

    refreshBranding();

    // 🔴 CRITICAL FIX: Stop and hide native Android ExoPlayer BEFORE splash starts
    if (window.AndroidVideoPlayer) {
      try {
        console.log("🧹 Calling stopVideo to clean up native ExoPlayer views");
        window.AndroidVideoPlayer.stopVideo();
        console.log("✅ Native ExoPlayer cleaned up");
      } catch (e) {
        console.error("❌ Error calling stopVideo:", e);
      }
    }

    const videoUrl = clientBranding().splashVideo;

    // Small delay to ensure DOM is ready AND native players are hidden
    const initTimer = setTimeout(() => {
      console.log("Starting splash video playback...");

      splashVideoPlayer
        .playVideo(videoUrl, "splash")
        .then(() => {
          console.log("✓ Splash video playing successfully");
          console.log("Player state:", splashVideoPlayer.getState());
        })
        .catch((error) => {
          console.error("✗ Splash video playback error:", error);
          // On error, clean up immediately
          splashVideoPlayer.destroy();
        });
    }, 100); // Increased delay slightly to ensure stopVideo completes

    // Cleanup function - VERY IMPORTANT
    onCleanup(() => {
      console.log("=== SplashScreen cleanup called ===");
      clearTimeout(initTimer);

      // Destroy web player
      splashVideoPlayer.destroy();

      // Extra safety: Force cleanup after a short delay
      setTimeout(() => {
        console.log("🧨 Extra safety cleanup");
        splashVideoPlayer.forceCleanup();

        // Final check for remaining video elements
        const remainingVideos = document.querySelectorAll('video');
        if (remainingVideos.length > 0) {
          console.warn(`⚠️ Still ${remainingVideos.length} video elements in DOM, removing...`);
          remainingVideos.forEach(video => {
            video.pause();
            video.src = "";
            if (video.parentNode) {
              video.parentNode.removeChild(video);
            }
          });
        }

        // 🔴 CRITICAL: Call stopVideo again on cleanup to ensure native players stay hidden
        if (window.AndroidVideoPlayer) {
          try {
            console.log("🧹 Final stopVideo call to ensure native players hidden");
            window.AndroidVideoPlayer.stopVideo();
          } catch (e) {
            console.warn("Could not call stopVideo on cleanup:", e);
          }
        }

        console.log("✅ Final cleanup complete");
      }, 100);
    });
  });

  return null;
};

export default SplashScreen;